import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { LandingPageCanino1 } from './pages/LandingPageCanino1';
import { LandingPageCanino2 } from './pages/LandingPageCanino2';
import { LandingPageCanino3 } from './pages/LandingPageCanino3';
import { LandingPageCanino4 } from './pages/LandingPageCanino4';
import { LandingPageCanino5 } from './pages/LandingPageCanino5';
import { LandingPageCanino6 } from './pages/LandingPageCanino6';
import { LandingPageCanino7 } from './pages/LandingPageCanino7';
import { LandingPageCanino8 } from './pages/LandingPageCanino8';
import { LandingPageCanino9 } from './pages/LandingPageCanino9';
import { LandingPageCanino10 } from './pages/LandingPageCanino10';
import { LandingPageCanino11 } from './pages/LandingPageCanino11';
import { LandingPageCanino12 } from './pages/LandingPageCanino12';
import { LandingPageCanino13 } from './pages/LandingPageCanino13';
import { MetaPixel } from './components/MetaPixel';
import { CountdownBar } from './components/CountdownBar';
import { FloatingCTA } from './components/FloatingCTA';
export function App() {
  return <>
      <MetaPixel data-id="element-0" />
      <CountdownBar data-id="element-1" />
      <FloatingCTA data-id="element-2" />

      <Router data-id="element-3">
        <Routes data-id="element-4">
          <Route path="/" element={<Navigate to="/canino1" replace data-id="element-6" />} data-id="element-5" />
          <Route path="/canino1" element={<LandingPageCanino1 data-id="element-8" />} data-id="element-7" />
          <Route path="/canino2" element={<LandingPageCanino2 data-id="element-10" />} data-id="element-9" />
          <Route path="/canino3" element={<LandingPageCanino3 data-id="element-12" />} data-id="element-11" />
          <Route path="/canino4" element={<LandingPageCanino4 data-id="element-14" />} data-id="element-13" />
          <Route path="/canino5" element={<LandingPageCanino5 data-id="element-16" />} data-id="element-15" />
          <Route path="/canino6" element={<LandingPageCanino6 data-id="element-18" />} data-id="element-17" />
          <Route path="/canino7" element={<LandingPageCanino7 data-id="element-20" />} data-id="element-19" />
          <Route path="/canino8" element={<LandingPageCanino8 data-id="element-22" />} data-id="element-21" />
          <Route path="/canino9" element={<LandingPageCanino9 data-id="element-24" />} data-id="element-23" />
          <Route path="/canino10" element={<LandingPageCanino10 data-id="element-26" />} data-id="element-25" />
          <Route path="/canino11" element={<LandingPageCanino11 data-id="element-28" />} data-id="element-27" />
          <Route path="/canino12" element={<LandingPageCanino12 data-id="element-30" />} data-id="element-29" />
          <Route path="/canino13" element={<LandingPageCanino13 data-id="element-32" />} data-id="element-31" />
          <Route path="/original" element={<LandingPage data-id="element-34" />} data-id="element-33" />
        </Routes>
      </Router>
    </>;
}